import*as n from"react";function r(n,r){"function"==typeof n?n(r):n&&(n.current=r)}function e(...e){return n.useMemo((()=>e.every((n=>null==n))?null:n=>{e.forEach((e=>{r(e,n)}))}),e)}export{r as s,e as u};
//# sourceMappingURL=useForkRef-4fb0c1b2.js.map
